import { IIdentityProviderResponse } from '@kcftech/prometheustypescriptapiclient';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { buildOrderBy, toDataSourceResult } from 'utils/query_v3';

export type IdentityProvidersFilter = Readonly<{
    nameSearch: string | undefined;
}>;

export type UseIdentityProvidersDataSourceOptions = BaseDataSourceOptions<
    IIdentityProviderResponse,
    IdentityProvidersFilter
>;

export type IdentityProvidersPagedDataSource = PagedDataSource<
    IIdentityProviderResponse,
    IdentityProvidersFilter
>;

const queryFn: DataSourceQuery<IIdentityProviderResponse, IdentityProvidersFilter> = ({
    filter: { nameSearch },
    sort,
    page,
    pageLimit,
}) => {
    const orderBy = buildOrderBy(sort);
    return toDataSourceResult(
        sdClient.getIdentityProviders({
            page,
            pageLimit,
            orderBy,
            nameSearch,
        })
    );
};

export function usePagedIdentityProvidersDataSource(
    options: UseIdentityProvidersDataSourceOptions
): IdentityProvidersPagedDataSource {
    return usePagedDataSource({
        ...options,
        query: queryFn,
    });
}
